import * as ProtoHallNotify from "./proto_hall_gameserver_notify";
import NetMsgDataToBuffer from "../../../../framework/net/net_msgdata_to_buffer";




export class NetMsgDataMapHallNotify extends NetMsgDataToBuffer {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:1为登录服，2为麻将游戏服，3为Skynet扑克服
    static Ping: any[] = ["Hall.PingReq", ProtoHallNotify.ProtoHallServerNotify.PingReq, "Hall.PingRsp", ProtoHallNotify.ProtoHallServerNotify.PingRsp, 3]
    static Login: any[] = ["Hall.LoginReq", ProtoHallNotify.ProtoHallServerNotify.LoginReq, "Hall.LoginRsp", ProtoHallNotify.ProtoHallServerNotify.LoginRsp, 3]
    static EnterGameHall: any[] = ["Hall.EnterGameHallReq", ProtoHallNotify.ProtoHallServerNotify.EnterGameHallReq, "Hall.EnterGameHallRsp", ProtoHallNotify.ProtoHallServerNotify.EnterGameHallRsp, 3]
    static NotifyHallData: any[] = ["Hall.NotifyHallData", ProtoHallNotify.ProtoHallServerNotify.NotifyHallData, "Hall.NotifyHallData", ProtoHallNotify.ProtoHallServerNotify.NotifyHallData, 3]
    static NotifyRoomTypeData: any[] = [null, null, "Hall.NotifyRoomTypeData", ProtoHallNotify.ProtoHallServerNotify.NotifyRoomTypeData, 3]

}
